function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import * as RadixTooltip from '@radix-ui/react-tooltip';
import * as S from './Tooltip.styles';
const TooltipProvider = RadixTooltip.TooltipProvider;
const Tooltip = /*#__PURE__*/React.forwardRef(({
  align,
  alignOffset,
  ariaLabel,
  arrowPadding,
  avoidCollisions,
  collisionBoundary,
  collisionPadding,
  content,
  defaultOpen,
  delayDuration = 0,
  disableHoverableContent,
  hideWhenDetached,
  onOpenChange,
  open,
  side,
  sideOffset = 0,
  sticky,
  children,
  translationThreshold
}, ref) => {
  const rootProps = {
    defaultOpen,
    delayDuration,
    disableHoverableContent,
    onOpenChange,
    open
  };
  const contentProps = {
    'aria-label': ariaLabel,
    align,
    alignOffset,
    arrowPadding,
    avoidCollisions,
    collisionBoundary,
    collisionPadding,
    hideWhenDetached,
    side,
    sideOffset,
    sticky
  };
  return /*#__PURE__*/React.createElement(RadixTooltip.Root, rootProps, /*#__PURE__*/React.createElement(RadixTooltip.Trigger, {
    asChild: true
  }, /*#__PURE__*/React.createElement(S.TooltipButton, {
    type: "button",
    ref: ref
  }, children ?? /*#__PURE__*/React.createElement(S.StyledInfoIcon, {
    size: "medium",
    variant: "bold"
  }))), /*#__PURE__*/React.createElement(RadixTooltip.Portal, null, /*#__PURE__*/React.createElement(S.TooltipContent, _extends({}, contentProps, {
    $translationThreshold: translationThreshold
  }), content, /*#__PURE__*/React.createElement(S.TooltipArrow, null))));
});
export { Tooltip, TooltipProvider };